// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3tYLN","dragIcon":"Choice_dragIcon__2sTy9","left":"Choice_left__2rgwi","input":"Choice_input__2T5fT"};